// Shared event helper for GA4, the Meta Pixel, and the Pinterest tag. Routes
// every custom event through one place so test/dev traffic is excluded
// consistently across all three - added after manual test orders polluted
// production Analytics data. window.__trackingEnabled is set once in
// public/index.html (same production-hostname / ?ga_test=1 check gates all
// providers there).

const GA4_EVENT_TO_META = {
  begin_checkout: "InitiateCheckout",
  add_payment_info: "AddPaymentInfo",
  purchase: "Purchase",
  site_search: "Search",
  // Standard event, not just the custom one below, so it's directly
  // selectable as a Conversion goal in Ads Manager without a Custom
  // Conversion set up first.
  funnel_option_click: "Lead",
};

// Pinterest's standard events don't distinguish checkout-started from
// checkout-completed the way GA4/Meta do - "checkout" is their purchase
// event, so only the funnel's actual conversion points map here.
const GA4_EVENT_TO_PINTEREST = {
  purchase: "checkout",
  site_search: "search",
};

function toMetaParams(eventName, params) {
  switch (eventName) {
    case "begin_checkout":
    case "add_payment_info":
    case "purchase":
      return {
        value: params.value,
        currency: params.currency,
        num_items: Array.isArray(params.items) ? params.items.length : undefined,
        content_ids: Array.isArray(params.items)
          ? params.items.map((item) => item.item_id)
          : undefined,
        contents: Array.isArray(params.items)
          ? params.items.map((item) => ({
              id: item.item_id,
              quantity: item.quantity,
              item_price: item.price,
            }))
          : undefined,
        content_type: "product",
      };
    case "site_search":
      return { search_string: params.search_term };
    case "funnel_option_click":
      return { content_name: params.option, content_category: "ad_funnel" };
    default:
      return {};
  }
}

function toPinterestParams(eventName, params) {
  switch (eventName) {
    case "purchase":
      return {
        value: params.value,
        currency: params.currency,
        order_id: params.transaction_id,
        line_items: Array.isArray(params.items)
          ? params.items.map((item) => ({
              product_id: item.item_id,
              product_name: item.item_name,
              product_quantity: item.quantity,
              product_price: item.price,
            }))
          : undefined,
      };
    case "site_search":
      return { search_query: params.search_term };
    default:
      return {};
  }
}

export function trackEvent(eventName, params = {}) {
  if (typeof window === "undefined" || !window.__trackingEnabled) {
    return;
  }

  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }

  const metaEvent = GA4_EVENT_TO_META[eventName];
  if (metaEvent && typeof window.fbq === "function") {
    window.fbq("track", metaEvent, toMetaParams(eventName, params));
  }

  const pinterestEvent = GA4_EVENT_TO_PINTEREST[eventName];
  if (pinterestEvent && typeof window.pintrk === "function") {
    window.pintrk("track", pinterestEvent, toPinterestParams(eventName, params));
  }
}
